import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { ModalTypes, ModalService } from "../service/modal-service";
import CreateServerModal from "../module/server/create";
import JoinServerModal from "../module/server/join";
import ImportModule from "../module/library/import";

import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Box } from "../comps";
import { Z_INDEX } from "../constants";
import { IS_ELECTRON_APP } from "../config";

// TODO : if electron head height changes
const ModalWrapper = styled(Row)`
  position: fixed;
  width: 100vw;
  height: ${IS_ELECTRON_APP ? "95vh" : "100vh"};
  top: ${IS_ELECTRON_APP ? "5vh" : "0vh"};
  align-items: center;
  background: #000000d9;
  z-index: ${Z_INDEX.modal};
  justify-content: center;
`;

const Container = styled(Box)`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: #fff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
  /* border-radius: 10px; */
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
`;

const Content = styled(Box)`
  width: 100%;
  height: 100%;
`;

const CrossIcon = styled(Box)`
  position: fixed;
  top: 2%;
  right: 3%;
`;

export default () => {
  const [modalInfo, setModalInfo] = useState({});
  const { type: modalType, data: modalData } = modalInfo;

  const modalStateManager = (type, data) => {
    if (!type) setModalInfo({});
    else setModalInfo({ type, data });
  };

  useEffect(() => {
    ModalService.register(modalStateManager);
  }, []);

  const handleClose = () => {
    ModalService.closeModal();
  };

  let modalContent = "",
    modalWidth = "0px",
    modalHeight = "0px";

  switch (modalType) {
    case ModalTypes.SERVER_CREATE:
      modalContent = <CreateServerModal close={handleClose} />;
      modalWidth = "600px";
      modalHeight = "300px";
      break;
    case ModalTypes.SERVER_JOIN:
      modalContent = <JoinServerModal close={handleClose} />;
      modalWidth = "600px";
      modalHeight = "300px";
      break;
    case ModalTypes.IMPORT:
      modalContent = <ImportModule close={handleClose} modalData={modalData} />;
      modalWidth = "1200px";
      modalHeight = "600px";
      break;
    case ModalTypes.CUSTOM:
      const { width, height, content } = modalData;
      modalWidth = width;
      modalHeight = height;
      modalContent = content;
      break;
  }

  if (!modalContent) return null;

  return (
    <ModalWrapper>
      <Container width={modalWidth} height={modalHeight}>
        <Content>{modalContent}</Content>
      </Container>
      <CrossIcon>
        <MaterialIconButton onClick={handleClose}>
          <FontAwesomeIcon
            style={{ fontSize: "30px", color: "#ffffff99" }}
            icon={faTimes}
          />
        </MaterialIconButton>
      </CrossIcon>
    </ModalWrapper>
  );
};
